import { useState, FormEvent } from 'react';

export default function BookingSection() {
  const [formData, setFormData] = useState({
    vorname: '',
    nachname: '',
    email: '',
    telefon: '',
    service: '',
    nachricht: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('vorname', formData.vorname);
      formBody.append('nachname', formData.nachname);
      formBody.append('email', formData.email);
      formBody.append('telefon', formData.telefon);
      formBody.append('service', formData.service);
      formBody.append('nachricht', formData.nachricht);

      const response = await fetch('https://readdy.ai/api/form/d6l9jv05dsf7sr1n5rlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          vorname: '',
          nachname: '',
          email: '',
          telefon: '',
          service: '',
          nachricht: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="buchung" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Buchungsformular
            </h2>
            <p className="text-xl text-gray-600">
              Kontaktieren Sie uns für ein unverbindliches Angebot
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <form id="booking-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="vorname" className="block text-sm font-semibold text-gray-700 mb-2">
                    Vorname <span className="text-orange-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="vorname"
                    name="vorname"
                    value={formData.vorname}
                    onChange={(e) => setFormData({...formData, vorname: e.target.value})}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="nachname" className="block text-sm font-semibold text-gray-700 mb-2">
                    Nachname <span className="text-orange-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="nachname"
                    name="nachname"
                    value={formData.nachname}
                    onChange={(e) => setFormData({...formData, nachname: e.target.value})}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                    E-Mail <span className="text-orange-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm"
                  />
                </div>
                <div>
                  <label htmlFor="telefon" className="block text-sm font-semibold text-gray-700 mb-2">
                    Telefonnummer
                  </label>
                  <input
                    type="tel"
                    id="telefon"
                    name="telefon"
                    value={formData.telefon}
                    onChange={(e) => setFormData({...formData, telefon: e.target.value})}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="service" className="block text-sm font-semibold text-gray-700 mb-2">
                  Gewünschte Dienstleistung <span className="text-orange-500">*</span>
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={(e) => setFormData({...formData, service: e.target.value})}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm cursor-pointer"
                >
                  <option value="">Bitte wählen...</option>
                  <option value="Haushaltsauflösung">Haushaltsauflösung</option>
                  <option value="Entrümpelung">Entrümpelung</option>
                  <option value="Möbeltaxi">Möbeltaxi</option>
                  <option value="Kleiner Umzug">Kleiner Umzug</option>
                  <option value="Ankauf Wertgegenstände">Ankauf Wertgegenstände</option>
                  <option value="Sonstiges">Sonstiges</option>
                </select>
              </div>

              <div className="mb-6">
                <label htmlFor="nachricht" className="block text-sm font-semibold text-gray-700 mb-2">
                  Ihre Nachricht <span className="text-orange-500">*</span>
                </label>
                <textarea
                  id="nachricht"
                  name="nachricht"
                  value={formData.nachricht}
                  onChange={(e) => {
                    if (e.target.value.length <= 500) {
                      setFormData({...formData, nachricht: e.target.value});
                    }
                  }}
                  required
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors resize-none text-sm"
                  placeholder="Beschreiben Sie bitte Ihr Anliegen..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">
                  {formData.nachricht.length}/500 Zeichen
                </p>
              </div>

              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-50 border-2 border-green-200 rounded-lg">
                  <p className="text-green-700 font-medium text-sm">
                    <i className="ri-check-line mr-2"></i>
                    Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet. Wir melden uns in Kürze bei Ihnen.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-50 border-2 border-red-200 rounded-lg">
                  <p className="text-red-700 font-medium text-sm">
                    <i className="ri-error-warning-line mr-2"></i>
                    Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder rufen Sie uns direkt an.
                  </p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-orange-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Wird gesendet...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line mr-2"></i>
                    Anfrage senden
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}